import { Flex, type MenuProps } from 'antd';
import { StyledCard } from '@app/components/card/Card';
import { DateRangeSelect } from '@app/components/date-range-select/DateRangeSelect';
import { ActionsDropdown } from '@app/components/actions-dropdown/ActionsDropdown';
import useChannelPartners from '@app/hooks/channelPartners/useChannelPartners';

type MenuItem = NonNullable<MenuProps['items']>[number];

type FiltersCardProps = {
    channelPartnersIds: string[];
    updateChannelPartnersIds: (id: string, action: 'select' | 'deselect') => void;
    updateDates: (dateRange: { start: string; end: string }) => void;
};

const FiltersCard = ({
    channelPartnersIds,
    updateChannelPartnersIds,
    updateDates,
}: FiltersCardProps) => {
    const { data: channelPartnersData, isLoading: loadingPartners } = useChannelPartners({
        per_page: 99999,
    });
    const channelPartnersOpts: MenuItem[] = [
        ...(channelPartnersData?.data?.map((i) => ({ key: i.id, label: i.name })) ?? []),
        { type: 'divider' },
        { key: 'reset', label: <span className="text-red">Clear</span> },
    ];
    return (
        <StyledCard className="filters-card">
            <Flex vertical={true} gap={20}>
                <DateRangeSelect dynamicMonthOptions={true} onSelectionChange={updateDates} />
                <ActionsDropdown
                    title={
                        <>
                            {'Channel Partners'}
                            {Boolean(channelPartnersIds?.length) && (
                                <span> ({channelPartnersIds?.length})</span>
                            )}
                        </>
                    }
                    items={channelPartnersOpts}
                    menu={{
                        selectable: true,
                        selectedKeys: channelPartnersIds,
                        multiple: true,
                        onSelect: ({ key }) => {
                            updateChannelPartnersIds(key, 'select');
                        },
                        onDeselect: ({ key }) => {
                            updateChannelPartnersIds(key, 'deselect');
                        },
                    }}
                    disabled={loadingPartners}
                />
                <div>
                    <ul>
                        {channelPartnersIds.length &&
                        channelPartnersIds.length !== channelPartnersData?.data?.length ? (
                            channelPartnersIds.map((id) => {
                                const partner = channelPartnersData?.data?.find((p) => p.id === id);
                                if (partner) {
                                    return <li key={id}>{partner.name}</li>;
                                }
                            })
                        ) : (
                            <li>All Channel Partners</li>
                        )}
                    </ul>
                </div>
            </Flex>
        </StyledCard>
    );
};

export default FiltersCard;
